import { Component } from 'preact'
import axios from 'axios'
import { t } from '../../libs/translationsUtils/translations'
import TopicListItemView, { TopicInfo } from './TopicListItemView.sync'
import Analytics from '../analytics/Analytics'
import { common } from '../common'
import { z } from 'zod'

export const queryZodType = z.object({
  sort: z.string(),
  sortOrder: z.string(),
  minReplies: z.number(),
  maxResults: z.number(),
  contentType: z.union([z.string(), z.undefined()]),
  hasBestAnswer: z.union([z.boolean(), z.undefined()])
})

export type QueryType = z.infer<typeof queryZodType>

export interface TopicsListViewProps {
  topics: TopicInfo[]
  query: QueryType
  requestUrl: string
  attachmentCdn: string
}

interface State {
  page: number
  isLoading?: boolean
  isDone?: boolean
  topics: TopicsListViewProps['topics']
}

export default class TopicListView extends Component<TopicsListViewProps, State> {
  constructor (props: TopicsListViewProps) {
    super(props)

    this.state = {
      page: 1,
      topics: props.topics || []
    }

    this.getTopicData = this.getTopicData.bind(this)
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  componentDidMount () {
    const { query } = this.props
    const newQuery = { ...query, page: 1 }

    if (!this.state.topics) this.getTopicData(newQuery)
  }

  getTopicData (query: {page: number}) {
    const { requestUrl } = this.props
    const { topics } = this.state

    this.setState({
      isLoading: true
    })

    const topicDataCall = async () => {
      const res = await axios.get(requestUrl, {
        params: {
          query: JSON.stringify(query)
        }
      })

      const { data: newTopics } = res
      const newData = (topics || []).concat(newTopics)

      this.setState({
        topics: newData,
        page: query.page,
        isDone: newTopics.length < 10,
        isLoading: false
      })
    }

    topicDataCall()
  }

  showMoreHandler () {
    const { query } = this.props
    const { page } = this.state
    const newQuery = { ...query, page: page + 1 }

    Analytics.send('Homepage', 'Show more activity clicked')

    this.getTopicData(newQuery)
  }

  render (props: TopicsListViewProps, state: State) {
    const { attachmentCdn } = props
    const { topics, isDone, isLoading } = state
    let btnClass = 'btn--cta btn--full-width btn--load-more'
    let disabledButton = false

    if (!topics) {
      return null
    }

    if (isLoading) {
      btnClass += ' is-loading'
      disabledButton = true
    }

    return (
      <div className='list-widget-wrapper'>
        {
          topics.map(topic => {
            return (
              <TopicListItemView
                key={topic.id}
                topic={topic}
                attachmentCdn={attachmentCdn}
                hideCategoryMetadata={((topic.type === 'ideation' && common.isModuleActive('ideationV2')) || topic.contentType === 'productUpdate')}
              />
            )
          })
        }
        {
          !isDone
            ? (
              <div class='load-more-container load-more-topics'>
                <button class={btnClass} onClick={this.showMoreHandler} type='button' disabled={disabledButton}>
                  {t('Forum', 'Show more')}
                  <span class='loader' />
                </button>
              </div>
              )
            : null
        }
      </div>
    )
  }
}
